<table
  [class.hidden]="loadingRepairers"
  #tableSort="matSort"
  (matSortChange)="activeColumn = $event.active"
  [dataSource]="tableDataSource"
  mat-table
  matSort
  matSortActive="companyName"
  matSortDirection="asc"
  matSortDisableClear>
  @for (columnInfo of columnInfos; track columnInfo) {
    <ng-container [matColumnDef]="columnInfo?.matColumnDef">
      @if (!['kebab', 'status', 'flagged'].includes(columnInfo?.matColumnDef)) {
        <th
          (click)="columnHeaderOrderChange.emit({ sort: tableSort?.active, direction: tableSort?.direction })"
          *matHeaderCellDef
          [class.active]="activeColumn === columnInfo?.matColumnDef"
          mat-header-cell
          mat-sort-header>
          {{ columnInfo?.columnTitle }}
        </th>
      } @else {
        <th *matHeaderCellDef [class.active]="activeColumn === columnInfo?.matColumnDef" mat-header-cell>
          {{ columnInfo?.columnTitle ?? '' }}
        </th>
      }
      <td *matCellDef="let item" mat-cell>
        @if (
          !['status', 'kebab', 'mainContact.phone', 'published', 'flagged', 'suspended'].includes(
            columnInfo?.matColumnDef
          )
        ) {
          <span>
            {{ item | objectDeepValue: columnInfo.property }}
          </span>
        }
        @if ('mainContact.phone' === columnInfo?.matColumnDef) {
          <span>
            {{ item | objectDeepValue: (item?.phoneNumber ? 'phoneNumber' : 'mainContact.phone') }}
          </span>
        }
        @if ('published' === columnInfo?.matColumnDef && item.publishedDateTime) {
          <span>
            {{ item.publishedDateTime | dateepoch: currentUserTimezone }}
            {{ item.publishedDateTime | time: currentUserTimezone }}
          </span>
        }
        @if ('suspended' === columnInfo?.matColumnDef && item.licenseSuspendedDate) {
          <span>
            {{ item.licenseSuspendedDate | dateepoch: currentUserTimezone }}
          </span>
        }
        @if (columnInfo?.matColumnDef === 'status' || columnInfo?.columnTitle === 'status') {
          <app-status-cell-info [data]="item" [currentUserTimezone]="currentUserTimezone"> </app-status-cell-info>
        }
        @if (columnInfo?.matColumnDef === 'flagged' && item.unpaidLicense) {
          <mat-icon class="size-18! text-18! text-red!" matTooltip="This repairer has an unpaid license fee">
            flag
          </mat-icon>
        }
        @if (columnInfo?.matColumnDef === 'kebab') {
          <mat-panel-description class="kebab-panel">
            <div class="secondary-icon">
              <button matIconButton (click)="$event.stopPropagation()" [matMenuTriggerFor]="revokeTokenMenu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #revokeTokenMenu="matMenu" class="kebab-menu">
                @for (kebabMenuButton of kebabMenuButtons | menuList: item : item?.status; track kebabMenuButton) {
                  <button
                    mat-menu-item
                    (click)="kebabMenuClicked.emit({ param: item, action: kebabMenuButton?.action })">
                    <span>{{ kebabMenuButton?.label }}</span>
                  </button>
                }
              </mat-menu>
            </div>
          </mat-panel-description>
        }
      </td>
    </ng-container>
  }

  <tr *matHeaderRowDef="columnHeaders" mat-header-row></tr>
  <tr
    *matRowDef="let row; columns: columnHeaders"
    mat-row
    [ngClass]="{ 'cursor-default': row.status === 'ARCHIVED' }"
    (click)="row.status !== 'ARCHIVED' && rowItemClicked.emit(+row.id)"></tr>
</table>
